// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1iNYH","name":"ConsentHeader_name__1NGa7","birthday":"ConsentHeader_birthday__DSoQi","skeleton":"ConsentHeader_skeleton__svNpG"};